import React, { useEffect, useState } from 'react';
import Card from '@mui/joy/Card';
import CardActions from '@mui/joy/CardActions';
import CardContent from '@mui/joy/CardContent';
import Checkbox from '@mui/joy/Checkbox';
import Divider from '@mui/joy/Divider';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import Input from '@mui/joy/Input';
import Typography from '@mui/joy/Typography';
import Button from '@mui/joy/Button';
import InfoOutlined from '@mui/icons-material/InfoOutlined';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import { initFincode } from "@fincode/js"
import ApiFetch from '../ApiFetch';
import { useLocation, useNavigate } from 'react-router';
import LoadingButton from '@mui/lab/LoadingButton';
import { Alert, Container, InputLabel, MenuItem, Select } from '@mui/material';

const DirectdebitRegist = (props) => {
    function registBank(param){
        return new ApiFetch().put(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payouts/bank",param).then((r)=>{
            return r.json()
        })
    }
    function deleteBank(){
      return new ApiFetch().delete(ApiFetch.API_PROTOCOL+"//"+ApiFetch.API_HOST+"/v1/payouts/bank").then((r)=>{
          return r.json()
      })
    }
    const [fincode,setFincode] = useState(null)
    const [bankName,setBankName] = useState("")
    const [bankCode,setBankCode] = useState("")
    const [branchName,setBranchName] = useState("")
    const [branchCode,setBranchCode] = useState("")
    const [number,setNumber] = useState("")
    const [holderName,setHolderName] = useState("")
    const [depositType,setDepositType] = useState("")
    const [name,setName] = useState("")
    const [nameHalf,setNameHalf] = useState("")
    const [registStart,setRegistStart] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const navigate = useNavigate()

  useEffect(() => {

  },[]);

  function submit(){
    setRegistStart(true)
    registBank({
      "bank_name":bankName,
      "bank_code":bankCode,
      "branch_name":branchName,
      "branch_code":branchCode,
      "deposit_type":depositType,
      "number":number,
      "name":name,
      "name_half":nameHalf
    }).then(r => {
        if(r.result){
            window.location.reload()
        } else {
            setRegistStart(false)
            setErrorMessage(r.errors)
        }
    })
  }
  function deleteBankInfo(){
    setRegistStart(true)
    deleteBank().then(r => {
        if(r.result){
            window.location.reload() 
        } else {
            setRegistStart(false)
            setErrorMessage(r.errors)
        }
    })
  }
  return (
    <Card
      variant="outlined"
      sx={{
        maxHeight: 'max-content',
        maxWidth: '100%',
        mx: 'auto',
        // to make the demo resizable
        overflow: 'auto',
        resize: 'horizontal',
      }}
    >
      <Typography level="title-lg" startDecorator={<InfoOutlined />}>
        振込先口座登録
      </Typography>
      <Divider inset="none" />
      <CardContent
        sx={{
          display: 'grid',
          gridTemplateColumns: 'repeat(2, minmax(80px, 1fr))',
          gap: 1.5,
        }}
      >
        <FormControl>
          <FormLabel>金融機関名 (Bank Name)</FormLabel>
          <Input endDecorator={<CreditCardIcon />} value={bankName} onChange={(e) => setBankName(e.target.value)} />
        </FormControl>
        <FormControl>
          <FormLabel>金融機関コード (Bank Code)</FormLabel>
          <Input endDecorator={<CreditCardIcon />} value={bankCode} onChange={(e) => setBankCode(e.target.value)} />
        </FormControl>
        <FormControl>
          <FormLabel>支店名 (Branch Name)</FormLabel>
          <Input endDecorator={<CreditCardIcon />} value={branchName} onChange={(e) => setBranchName(e.target.value)} />
        </FormControl>
        <FormControl>
          <FormLabel>支店コード (Branch Code)</FormLabel>
          <Input endDecorator={<CreditCardIcon />} value={branchCode} onChange={(e) => setBranchCode(e.target.value)} />
        </FormControl>
        <FormControl fullWidth>
          <FormLabel id="select-label">預金種別 (Deposit Type)</FormLabel>
          <Select
            labelId="select-label"
            value={depositType}
            label="預金種別 (Deposit Type)"
            onChange={(e) => setDepositType(e.target.value)}
          >
            <MenuItem value={1}>普通</MenuItem>
            <MenuItem value={2}>当座</MenuItem>
            <MenuItem value={4}>貯蓄</MenuItem>
          </Select>
        </FormControl>
        <FormControl sx={{ gridColumn: '1/-1' }}>
          <FormLabel>口座番号 (Account Number)</FormLabel>
          <Input endDecorator={<CreditCardIcon />} value={number} onChange={(e) => {setNumber(e.target.value)}}  />
        </FormControl>
        <FormControl>
          <FormLabel>口座名義 (Name)</FormLabel>
          <Input endDecorator={<CreditCardIcon />} value={name} onChange={(e) => setName(e.target.value)} />
        </FormControl>
        <FormControl>
          <FormLabel>口座名義カナ (Name Kana)</FormLabel>
          <Input endDecorator={<CreditCardIcon />} value={nameHalf} onChange={(e) => setNameHalf(e.target.value)} />
        </FormControl>
        <CardActions sx={{ gridColumn: '1/-1' }}>
          <LoadingButton loading={registStart} variant="contained" color="primary" onClick={() => submit()}>
            登録
          </LoadingButton>
        </CardActions>
        <Container sx={{ gridColumn: '1/-1' }}>
        {errorMessage.length > 0 ? <Alert severity='error' className='m-0'>{errorMessage}</Alert> : ""}
        </Container>
        <Container style={{border:"1px solid #DDDDDD"}} sx={{ gridColumn: '1/-1' }} className='p-3'>
          <Container sx={{ gridColumn: '1/-1' }} className='p-3' style={{color:"#555555",fontSize:"14px",backgroundColor:"#EEEEEE"}}>
            <b>振込先</b>&nbsp;
            {props.bank === undefined || props.bank.bank_name === undefined ? "未設定" : (
              <>{props.bank.bank_name} {props.bank.branch_name} {props.bank.number}</>
            )}
          </Container>
          <LoadingButton sx={{ gridColumn: '1/-1' }} className="mt-3 w-100" loading={registStart} onClick={() => deleteBankInfo()} disabled={props.bank === undefined || props.bank.bank_name === undefined}>
              削除
          </LoadingButton>
        </Container>
      </CardContent>
    </Card>
  );
};

export default DirectdebitRegist;